import { Prompt, Section } from '../loan-application.model';

export function parseSectionPrompts(section: Section) {
  section?.prompts?.forEach((prompt) => {
    prompt.promptValue = parsePromptValue(prompt);
  });
  return section;
}

export function parsePromptValue(prompt: Prompt) {
  switch (prompt?.promptType) {
    case 'Money': {
      if (typeof prompt?.promptValue === 'number' || !prompt?.promptValue) {
        return prompt?.promptValue;
      }
      const value = prompt?.promptValue?.replace(/[^0-9.]/g, '');
      return Number(value);
    }
    case 'CheckBox': {
      if (typeof prompt?.promptValue === 'boolean') {
        return prompt?.promptValue;
      }
      return prompt?.promptValue?.toLowerCase() === 'true';
    }
    case 'Date': {
      if (typeof prompt?.promptValue !== 'string') {
        return prompt?.promptValue;
      }
      return prompt?.promptValue ? new Date(prompt?.promptValue) : null;
    }
    default:
      return prompt?.promptValue;
  }
}

export function getSaveValue(prompt: Prompt): string {
  switch (prompt?.promptType) {
    case 'Money': {
      if (typeof prompt?.promptValue === 'string') {
        return prompt?.promptValue;
      }
      const value: number = prompt?.promptValue;
      return value !== null && value !== undefined ? `${value?.toFixed(2)}` : '';
    }
    case 'CheckBox': {
      if (typeof prompt?.promptValue === 'string') {
        return prompt?.promptValue;
      }
      const value: boolean = prompt?.promptValue;
      return value ? 'True' : 'False';
    }
    case 'Date': {
      if (!prompt?.promptValue) {
        return null;
      }
      const value = new Date(prompt?.promptValue);
      return value?.toLocaleDateString();
    }
    default:
      return prompt?.promptValue;
  }
}
